const SECTION_SELECTOR = '#MainContent > .shopify-section';
const READY_ATTR = 'data-scroll-reveal';
const VISIBLE_ATTR = 'data-scroll-reveal-visible';

const shouldReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const isDesignMode = document.documentElement.classList.contains('shopify-design-mode');
const observedSections = new WeakSet();

let observer = null;

function shouldSkipSection(section) {
  return (
    !section ||
    observedSections.has(section) ||
    section.matches('[data-no-scroll-reveal], .shopify-section-group-header-group, .shopify-section-group-footer-group')
  );
}

function revealSection(section) {
  section.setAttribute(VISIBLE_ATTR, '');
  observer?.unobserve(section);
}

function revealSectionSoon(section) {
  window.requestAnimationFrame(() => revealSection(section));
}

function prepareSection(section) {
  if (shouldSkipSection(section)) return;

  observedSections.add(section);
  section.setAttribute(READY_ATTR, '');

  if (shouldReduceMotion || isDesignMode) {
    revealSection(section);
    return;
  }

  const rect = section.getBoundingClientRect();
  if (rect.top < window.innerHeight * 0.88) {
    revealSectionSoon(section);
    return;
  }

  observer?.observe(section);
}

function registerSections(root = document) {
  root.querySelectorAll(SECTION_SELECTOR).forEach(prepareSection);
}

function initObserver() {
  if (shouldReduceMotion || isDesignMode) return;

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          revealSection(entry.target);
        }
      });
    },
    {
      threshold: 0.14,
      rootMargin: '0px 0px -8% 0px',
    }
  );
}

function init() {
  initObserver();
  registerSections();

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof HTMLElement) {
      prepareSection(event.target);
    }
  });

  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches?.(SECTION_SELECTOR)) {
          prepareSection(node);
        } else {
          registerSections(node);
        }
      });
    });
  });

  mutationObserver.observe(document.getElementById('MainContent') || document.body, {
    childList: true,
    subtree: true,
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
